import { Box, Divider, Typography } from "@mui/material";
import React from "react";
import { master_general_information_fields } from "../data";
import RenderInputField from "components/MboPaymentWorking/CommonComponents/RenderInputFiled/RenderInputFiled";

function MasterGeneralInformation({ value, setValue }) {
	return (
		<Box pl={2} width="100%">
			<Box display="flex" columnGap={"2%"} flexWrap="wrap">
				{master_general_information_fields?.map((row) => {
					return (
						<RenderInputField
							column={row}
							data={value}
							setData={setValue}
							width="40%"
							selectOptObjName={"option_data"}
							key={row.key}
						/>
					);
				})}
			</Box>
		</Box>
	);
}

export default MasterGeneralInformation;
